import { Injectable } from '@angular/core';

import { AnalysResultat, AnalysResultatDTO } from '../models/analys-resultat';
import { ApiService } from 'src/app/api/api.service';
import { Observable } from 'rxjs';
import { Inskicksresultat } from './inskicks-resultat.models';

@Injectable({
  providedIn: 'root',
})
export class InskicksResultatService {
  url = 'analysresultat';

  constructor(private apiService: ApiService) {}

  getResultat(): Observable<Map<String, Inskicksresultat[]>> {
    return this.apiService.getAsObservable('analysresultat14days');
  }

  getFindsByProvId(provId: string): Observable<any> {
    return this.apiService.getAsObservable(`analysresultat14days/finds/${provId}`);
  }
}
